import React from 'react';
import { CONFIG } from '../data/config';
import { LeafIcon } from 'lucide-react';
interface HeaderProps {
  onStartOrder: () => void;
}
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/imUssngbgqRzFtqWN6k7rL/ChatGPT_Image_10_mar_2026,_20_05_19.png';
export function Header({
  onStartOrder
}: HeaderProps) {
  return <header className="relative mb-0 overflow-hidden" style={{
    minHeight: 280
  }} data-id="element-201">
      {/* Background image */}
      <div className="absolute inset-0 will-change-transform" data-id="element-202">
        <img src={HERO_IMAGE} alt="" loading="eager" decoding="async" className="w-full h-full object-cover object-center" style={{
        willChange: 'auto'
      }} data-id="element-203" />
        <div className="absolute inset-0 bg-black/40" data-id="element-204" />
        <div className="absolute bottom-0 left-0 right-0 h-40" style={{
        background: 'linear-gradient(to top, #f8f8f6 0%, #f8f8f6 10%, transparent 100%)'
      }} data-id="element-205" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 pt-10 pb-14" data-id="element-206">
        <div className="w-24 h-24 rounded-full bg-white/95 shadow-2xl flex items-center justify-center mb-4 overflow-hidden border-[3px] border-white/60" data-id="element-207">
          <img src={CONFIG.LOGO_URL} alt={CONFIG.APP_NAME} loading="eager" decoding="async" width={96} height={96} className="w-full h-full object-cover" data-id="element-208" />
        </div>

        <h1 className="text-3xl font-heading font-bold text-white mb-1 drop-shadow-lg" data-id="element-209">
          {CONFIG.APP_NAME}
        </h1>

        <p className="text-white/80 text-sm mb-6 flex items-center justify-center gap-1.5 font-medium tracking-wide drop-shadow" data-id="element-210">
          <LeafIcon className="w-4 h-4 text-verde-light" data-id="element-211" />
          {CONFIG.APP_TAGLINE}
        </p>

        <button onClick={onStartOrder} className="bg-terracota text-white font-semibold py-3.5 px-10 rounded-full shadow-xl shadow-black/30 active:scale-95 transition-transform flex items-center gap-2 w-full max-w-xs justify-center border border-white/10 min-h-[48px]" data-id="element-212">
          Armá tu Bowl
          <LeafIcon className="w-5 h-5" data-id="element-213" />
        </button>
      </div>
    </header>;
}